var App = App || {};

App.WidgetSubpages = (function ($) {
    'use strict';

    const BpsMobile = ["xs", "sm", "md"];
    
    function CompareInit(selector) {

        // set up checkboxes functionality on load and reset when browser is resized through breakpoints
        if (selector.find(".widget-subpages-compare-controls").length) {
            CompareCheckboxes(selector);
            $(document).on("enter-xs enter-sm enter-md enter-lg enter-xl enter-xxl", function () { CompareCheckboxes(selector) });
        }

        // handle gratuitous animations that designer asked to occur when toggled from cards to compare
        const compareTab = $(`#${selector[0].id}_compare`);
        const comparePane = $(`#${selector[0].id}_compare_pane`);

        compareTab.on("shown.bs.tab", function () {
            comparePane.ZagScrollAnimate({
                offset: 75,
                targets: [
                    { selector: ".widget-subpages-compare", type: "animate__fadeInUp", stagger: 0 }
                ]
            });
        });
        InitDownloadPdf(selector);
    }

    function CompareCheckboxes(component) {

        var controls = component.find(".widget-subpages-compare-controls").find(".form-check-input");
        controls.on("change", function () {
            CompareCheckboxesUpdate(component);
        });

        const checkboxLimitsMax = CompareCheckboxesBasedOnBp().max;
        controls.prop("checked", false);
        controls.slice(0, checkboxLimitsMax).prop("checked", true);

        const controlPanel = controls.parents(".widget-subpages-compare-controls");
        if (controls.length <= checkboxLimitsMax) { controlPanel.hide(); }
        else { controlPanel.show(); }

        CompareCheckboxesUpdate(component);
    }

    function CompareCheckboxesUpdate(component) {

        const controls = component.find(".widget-subpages-compare-controls");
        const controlsChecked = controls.find("input:checked");
        const controlsUnchecked = controls.find("input:not(:checked)");
        const columnsShown = [];

        // disable checkboxes to enforce minimum and maximum checked
        const checkboxLimits = CompareCheckboxesBasedOnBp();

        if (controlsChecked.length >= checkboxLimits.max) {
            controlsUnchecked.attr("disabled", true);
        }
        else {
            controlsUnchecked.attr("disabled", false);
        }
        if (controlsChecked.length <= checkboxLimits.min) {
            controlsChecked.attr("disabled", true);
        }
        else {
            controlsChecked.attr("disabled", false);
        }

        // show/hide content based on checked controls
        controlsChecked.each(function () {
            columnsShown.push($(this).attr("id"));
        });

        component.find("[data-controlledby]").each(function () {
            var control = $(this).attr("data-controlledby");
            if (columnsShown.includes(control)) { $(this).show(); }
            else { $(this).hide(); }
        });
    }

    function CompareCheckboxesBasedOnBp() {

        let result;

        switch (ZagBreakpoints.GetBreakpoint()) {
            case 'xxl': result = { max: 4, min: 2 }; break;
            case 'xl': result = { max: 4, min: 2 }; break;
            case 'lg': result = { max: 3, min: 2 }; break;
            case 'md': result = { max: 3, min: 2 }; break;
            default: result = { max: 2, min: 1 };
        }
        return result;

    }

    function InitDownloadPdf(component) {

        document.querySelector(".widget-download-pdf")
            .addEventListener("click", function () {

                // ====================================
                // GET TABLE
                // ====================================

                const compareTable =
                    document.querySelector(".widget-subpages-compare-table");

                if (!compareTable) {
                    alert("Compare table not found");
                    return;
                }


                // ====================================
                // CLONE TABLE
                // ====================================

                const clonedTable = compareTable.cloneNode(true);

                // ====================================
                // BOOLEAN ICONS
                // ====================================

                clonedTable
                    .querySelectorAll(".item-subpage-field-data.Boolean")
                    .forEach(cell => {

                        const boolDiv =
                            cell.querySelector("div[aria-label]");

                        if (!boolDiv) return;

                        const value =
                            boolDiv.getAttribute("aria-label");

                        if (value === "True") {

                            cell.innerHTML = `
                <div class="print-check-icon">
                    ✓
                </div>
            `;

                        } else {

                            cell.innerHTML = `
                <div class="print-cross-icon">
                    —
                </div>
            `;
                        }
                    });

                // ====================================
                // CREATE FULL WIDTH SECTION ROWS
                // ====================================

                clonedTable
                    .querySelectorAll('.table-cell[role="rowheader"]')
                    .forEach(headerCell => {

                        const originalRow =
                            headerCell.closest('.table-row');

                        if (!originalRow) return;

                        const headerText =
                            headerCell.innerHTML.trim();

                        // create new full width row
                        const fullRow =
                            document.createElement('div');

                        fullRow.className =
                            'print-section-row';

                        fullRow.innerHTML = `
            <div class="print-section-cell">
                ${headerText}
            </div>
        `;

                        // insert before original row
                        originalRow.parentNode.insertBefore(
                            fullRow,
                            originalRow
                        );

                        // remove original row
                        originalRow.remove();

                    });

                // ====================================
                // HIDE LABEL COLUMN VISUALLY
                // KEEP VALUE ALIGNMENT
                // ====================================

                clonedTable
                    .querySelectorAll('.table-body .table-row')
                    .forEach(row => {

                        const firstCell =
                            row.querySelector('.table-cell');

                        if (!firstCell) return;

                        firstCell.style.fontSize = '0';
                        firstCell.style.padding = '24px 0px';
                        firstCell.style.border = 'none';
                        firstCell.style.background = 'transparent';
                        firstCell.style.width = '0';
                        firstCell.style.minWidth = '0';
                        firstCell.style.flex = '0';

                    });

                clonedTable
                    .querySelectorAll('.table-body .table-row')
                    .forEach(row => {

                        const firstCell =
                            row.querySelector('.visually-hidden');

                        if (!firstCell) return;

                        firstCell.style.fontSize = '0';
                        firstCell.style.padding = '24px 0px';
                        firstCell.style.border = 'none';
                        firstCell.style.background = 'transparent';
                        firstCell.style.width = '0';
                        firstCell.style.minWidth = '0';
                        firstCell.style.flex = '0';

                    });

                // ====================================
                // DISCLAIMER
                // ====================================

                const disclaimer =
                    document.querySelector(".disclaimer");

                // ====================================
                // OPEN WINDOW
                // ====================================

                const printWindow =
                    window.open(
                        "",
                        "_blank",
                        "width=1600,height=1000"
                    );

                // ====================================
                // START HTML
                // ====================================

                printWindow.document.write(`
        <html>

        <head>

        <title>
            Beacon Bank Checking Comparison
        </title>

        <style>

            /* =========================
               BASE
            ========================= */

            body{
                font-family:Arial,sans-serif;
                padding:20px;
                color:#002d62;
                background:#fff;
            }

            .print-header{
                margin-bottom:30px;
            }

            .print-header h2{
                margin:0;
                font-size:34px;
                font-weight:700;
                color:#000;
            }

            .print-date{
                margin-top:10px;
                font-size:14px;
                color:#555;
            }

            /* =========================
               MAIN TABLE
            ========================= */

            .widget-subpages-compare-table{
                display:block;
                width:100%;
            }

            .table-head,
            .table-body{
                display:block;
                width:100%;
            }

            .table-row{
                display:flex !important;
                width:100%;
            }

            .table-cell{
                flex:1 !important;
                border:1px solid #e3e3e3;
                padding:24px 18px;
                text-align:center;
                background:#fff;
                box-sizing:border-box;
            }

            /* =========================
               PRODUCT HEADER
            ========================= */

            .table-head .table-cell{
    background:#f7f7f7;
    padding:35px 20px;
}

.table-head h1,
.table-head h2,
.table-head h3{
    color:#003b71;
    font-size:30px;
    font-weight:700;
    margin-bottom:25px;
}

            .table-head ul{
                list-style:none;
                margin:0;
                padding:0;
            }

            .table-head a{
                display:inline-block;
                background:#003f78;
                color:#fff !important;
                text-decoration:none;
                padding:16px 42px;
                border-radius:40px;
                font-weight:700;
                font-size:16px;
            }

            /* =========================
               FULL WIDTH SECTION ROW
            ========================= */

            .print-section-row{
                width:100%;
                margin:0;
            }

            .print-section-cell{

                width:100%;

                background:#007fa3;
                color:#fff;

                text-align:center;

                font-size:24px;
                font-weight:700;

                padding:28px 20px;

                box-sizing:border-box;
            }

            /* =========================
               VALUE ROWS
            ========================= */

            .item-subpage-field-data{
                font-size:18px;
                line-height:1.5;
                color:#003b71;
                font-weight:500;
                word-break:break-word;
            }

            /* =========================
               BOOLEAN ICONS
            ========================= */

            .print-check-icon{
                font-size:28px;
                color:#007a33;
                font-weight:bold;
            }

            .print-cross-icon{
                font-size:24px;
                color:#999;
            }

            /* =========================
               LINKS
            ========================= */

            a{
                color:#003f78;
            }

            /* =========================
               CLEANUP
            ========================= */

            *{
                animation:none !important;
                transition:none !important;
                box-shadow:none !important;
            }

            .widget-subpages-compare-controls{
                display:none !important;
            }

            .animate__animated{
                animation:none !important;
            }

            /* =========================
               DISCLAIMER
            ========================= */

            .print-disclaimer{
                margin-top:40px;
                font-size:12px;
                line-height:1.7;
                color:#555;
            }

            /* =========================
               PRINT
            ========================= */

            @page{
                size:landscape;
                margin:12mm;
            }

            @media print{

                body{
                    -webkit-print-color-adjust:exact;
                    print-color-adjust:exact;
                }

            }

        </style>

        </head>

        <body>

            <div class="print-header">

                <h2>
                    Beacon Bank Checking Comparison
                </h2>

                <div class="print-date">
                    Generated on ${new Date().toLocaleDateString()}
                </div>

            </div>
    `);

                // ====================================
                // WRITE TABLE
                // ====================================

                printWindow.document.write(
                    clonedTable.outerHTML
                );

                // ====================================
                // DISCLAIMER
                // ====================================

                if (disclaimer) {

                    printWindow.document.write(`
            <div class="print-disclaimer">
                ${disclaimer.innerHTML}
            </div>
        `);

                } else {

                    printWindow.document.write(`
            <div class="print-disclaimer">
                <img src="/Images/header-fdic-badge.svg" 
                     alt="FDIC-Insured - Backed by the full faith and credit of the U.S. government" height="16" width="430">
                Refer to the full <a href="https://www.beaconbank.com/disclosures/truth-in-savings-disclosure">Consumer Truth in Savings Disclosure</a> for additional account information.
            </div>
        `);

                }

                // ====================================
                // END HTML
                // ====================================

                printWindow.document.write(`
        </body>
        </html>
    `);

                printWindow.document.close();

                // ====================================
                // PRINT
                // ====================================

                printWindow.onload = function () {

                    setTimeout(() => {

                        printWindow.focus();
                        printWindow.print();

                    }, 500);

                };

            });
    }


    return {
        CompareInit: CompareInit
    };

})(jQuery);